import { Skeleton } from "src/components/Skeleton/Skeleton";
import { Button } from "src/design-system/components/Button/Button";
import { FormattedMessage } from "react-intl";
import {
  PricingInfoLoading,
  RatingWithScoreLoading,
  TagsLoading,
  TitleLoading,
} from "./LoadingComponents";
import messages from "./messages";

export function ListCardMobileLoading() {
  return (
    <div className="relative flex min-h-54 gap-1 rounded-lg border-1 border-border bg-fill-solid p-1">
      <Skeleton width={125} height="" borderRadius="rounded_md" />

      <div className="flex flex-grow-1 basis-0 flex-col justify-between gap-2 p-3">
        <TitleLoading />
        <RatingWithScoreLoading />
        <TagsLoading />
        <div className="flex flex-row flex-wrap justify-end gap-x-4 gap-y-1">
          <PricingInfoLoading />
          <Button variant="primary" isDisabled>
            <FormattedMessage {...messages.callToAction} />
          </Button>
        </div>
      </div>
    </div>
  );
}
